module.exports = __webpack_public_path__ + "img/8.9c7c6bd5.webp";